<template>
  <b-overlay
    variant="primary"
    :show="isLoading"
    rounded="sm"
    opacity="0.25"
  >
    <b-card
      class="earnings-card"
    >
      <b-row>
        <b-col cols="6">
          <b-card-title
            class="ml-25"
          >
            <b-link
              class="text-primary.lighten-3"
              :to="{name : 'list-' + table }"
            >
              <feather-icon
                size="24"
                class="mr-1"
                :icon="icon + 'Icon'"
              />{{ $t('home.' + table) }}
            </b-link>
          </b-card-title>
          <h1 class="font-large-2 font-weight-bolder mt-2 mb-0">
            {{ formatNumber(counter) }}
          </h1>
          <b-card-text class="font-small-2">
            <span>{{ $t('common.last-update') }}: </span><span class="font-weight-bolder">{{ formatDate(lastUpdate) }}</span>
          </b-card-text>
        </b-col>
        <b-col cols="6">
          <!-- chart -->
          <vue-apex-charts
            v-if="chartsData"
            height="120"
            :options="chartsData.chartOptions"
            :series="chartsData.series"
          />
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BCardTitle, BCardText, BLink, BOverlay,
} from 'bootstrap-vue'
import axios from '@axios'
import VueApexCharts from 'vue-apexcharts'
import { formatNumber, formatDateHumanFriendly } from '@/views/layouts/layouts.utils'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardTitle,
    BCardText,
    VueApexCharts,
    BLink,
    BOverlay,
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    refaid: {
      required: true,
    },
    table: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      counter: null,
      lastUpdate: null,
      isLoading: false,
      chartsData: null,
    }
  },
  mounted() {
    this.$watch('refaid', () => {
      this.refetchData()
    }, { immediate: true })
  },
  methods: {
    formatNumber(value) {
      return formatNumber(value)
    },
    formatDate(value) {
      return formatDateHumanFriendly(value)
    },
    refetchData() {
      if (this.refaid) {
        this.isLoading = true
        axios.post(`/api/lists/${this.table}.counters`, {
          aid: this.refaid,
          params: { },
          filters: { },
        })
          .then(response => {
            const { items } = response.data
            if (items.length === 0) {
              items.push({
                label: 'N.D.',
                total_count: 0,
                lastUpdate: '',
              })
            }
            this.counter = items.reduce((sum, item) => sum + item.total_count, 0)
            this.lastUpdate = items.length > 0 ? items.reduce((prev, current) => ((prev.lastUpdate > current.lastUpdate) ? prev : current)).lastUpdate : null
            this.chartsData = this.refetchCharts(items, this.counter)
            this.isLoading = false
          })
      }
    },
    refetchCharts(items, total) {
      const max = items.reduce((prev, current) => ((prev.total_count > current.total_count) ? prev : current))
      const colors = []
      for (let i = 1; i < items.length; i += 1) {
        const perc = Math.min(parseInt((i / (items.length - 1)) * 100, 0), 99)
        colors.push(`${this.color}${perc < 10 ? '0' : ''}${perc}`)
      }
      colors.push(this.color)
      return {
        series: items.map(i => i.total_count),
        chartOptions: {
          chart: {
            type: 'donut',
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          labels: items.map(i => i.label),
          stroke: { width: 0 },
          colors,
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      return `${total !== 0 ? parseInt((val / total) * 100, 0) : '-'}%`
                    },
                  },
                  total: {
                    show: true,
                    offsetY: 15,
                    label: max.label,
                    formatter() {
                      return `${total !== 0 ? parseInt((max.total_count / total) * 100, 0) : '-'}%`
                    },
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 1325,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
            {
              breakpoint: 1045,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
          ],
        },
      }
    },
  },
}
</script>
